// import React from 'react'
// import { Link } from 'react-router-dom'
// import LOGO from '../Assets/Images/Farooq-LOGO.png'

// function Navbar() {
//   return (
//     <div>
//       <nav class="navbar px-4 py-3 navbar-expand-lg navbar-light bg-light">
//   <div class="container-fluid">
//     <Link class="navbar-brand" href="#"><img src={LOGO} alt="" /></Link>
//     <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//       <span class="navbar-toggler-icon"></span>
//     </button>
//     <div class="collapse navbar-collapse" id="navbarSupportedContent">
//       <ul class="navbar-nav ms-auto  mb-2 mb-lg-0">
//         <li class="nav-item">
//           <Link class="nav-link active" aria-current="page" to="/">Home</Link>
//         </li>
//         <li class="nav-item">
//           <Link class="nav-link" to="/about-company">Company</Link>
//         </li>

//         <li class="nav-item">
//           <Link class="nav-link" to="/our-services">Services</Link>
//         </li>

//         <li class="nav-item">
//           <Link class="nav-link"  to="/our-work">Our Work</Link>
//         </li>

//         <li class="nav-item">
//           <Link class="nav-link" to="/our-clients">Our Clients</Link>
//         </li>

//         <li class="nav-item">
//           <Link class="nav-link" to="/contact">Contact</Link>
//         </li>
        
        
//       </ul>
      
//     </div>
//   </div>
// </nav>
//     </div>
//   )
// }

// export default Navbar




import React, {useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import LOGOWhite from '../../src/Assets/Images/LOGO-white.png'

function Navbar() {


  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => setCollapsed(!collapsed);
  const closeNavbar = () => setCollapsed(true);

  const activeLink = (link) => {
    return location.pathname === link ? 'active' : '';
  };

  return (
    <div>
      <nav className="navbar px-4 py-1 navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/" onClick={closeNavbar}>
            <img src={LOGOWhite} alt="logo" />
          </Link>
          <button
            className={`navbar-toggler ${collapsed ? '' : 'collapsed'}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={!collapsed}
            aria-label="Toggle navigation"
            onClick={toggleNavbar}
          >
            <span className="navbar-toggler-icon text-light"></span>
          </button >
          <div className={`collapse navbar-collapse ${collapsed ? '' : 'show'}`} id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0" onClick={closeNavbar}>
              <li className="nav-item">
                <Link className={`nav-link active ${activeLink('/')}`} aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${activeLink('/about-company')}`} to="/about-company">
                  Company
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${activeLink('/our-services')}`} to="/our-services">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${activeLink('/our-work')}`} to="/our-work">
                  Our Work
                </Link>
              </li>
              
              <li className="nav-item">
                <Link className={`nav-link ${activeLink('/contact')}`} to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
            <div className="d-flex text-light align-items-center">
              
              <i className="me-2 fab fa-facebook"></i>
              <i className="me-2 fab fa-twitter"></i>
              <i className="fab fa-instagram"></i>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;

